import React, { Component } from 'react';
import { Form, message } from 'antd';
import { queryBusinessInfo } from '@api/common/business';
import AddressFree from './AddressFree';
import AddressPayable from './AddressPayable';
import './end.less';

class PageAddressEnd extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataInfo: {},
    };
  }

  componentWillMount() {}

  componentDidMount() {
    this.files = [];
    this.businessInfo();
  }

  /** 合同详情 */
  businessInfo = () => {
    const data = this.props.data || {};
    queryBusinessInfo({
      businessUuid: this.props.params.uuid || data.business.uuid,
    }).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          dataInfo: res.data,
        });
      } else {
        message.error(res.message);
      }
    });
  };

  render() {
    const { dataInfo } = this.state;
    const parentProps = {
      ...this.props,
      dataInfo,
    };
    return (
      <div>
        {dataInfo.price ? <AddressPayable {...parentProps} /> : <AddressFree {...parentProps} />}
      </div>
    );
  }
}

export default Form.create({ wrappedComponentRef: true })(PageAddressEnd);



// WEBPACK FOOTER //
// ./src/components/incubator/contract/end/PageAddressEnd.js